import { useCallback } from "react"
import { setModalCloseButton, setModalContainerContent, setModalContainerOpen } from "../../application/states/modal-container"
import { useAppDispatch } from "../../presentation/hooks/store-hooks"

export const useModalContainerService = () => {
  const dispatch = useAppDispatch()
  
  const openModal = useCallback((data: {
    content: JSX.Element,
    closeButton?: boolean
  }) => {
    dispatch(setModalContainerContent(data.content))
    dispatch(setModalContainerOpen(true))
    dispatch(setModalCloseButton(data.closeButton ?? false))
  }, [dispatch])
  
  const closeModal = useCallback(() => {
    dispatch(setModalContainerOpen(false))
  }, [dispatch])

  return {
    openModal,
    closeModal
  }
}